/**
 * Finds an item by `id` and merges `changes` into it in-place.
 * Safe for Immer (used by Redux Toolkit): direct mutation through the proxy
 * avoids bracket-notation object injection sinks (security/detect-object-injection).
 */
export function updateById<T extends { id: string }>(items: T[], id: string, changes: Partial<T>): void {
  const item = items.find(i => i.id === id);
  if (item) {
    Object.assign(item, changes);
  }
}
